<template>
    <div  class="mpro">
        <div class="bgImg">
            <img src="../assets/aem/pbg.png" alt="">
        </div>
        <div class="allImgs wow fadeInUp">
            <swiper class="swiper" :options="swiperOption" ref="mySwipers">
                <swiper-slide class="item" v-for="(item,index) in products" :key="index">
                  <div class="left" @click="gotoInfo(item.id)">
                      <img :src="`http://www.bodenstil.com/${item.infopic}`" alt="">
                  </div>
                    <div class="right"   @click="gotoInfo(item.id)">
                        <div class="title">
                            <p>产品中心</p>
<!--                            <p> Amuer brings you the pure elegant life</p>-->
                        </div>
                        <div class="nr" v-html="item.info">

                        </div>
                        <aBtn page="pro" color="#61605A"></aBtn>
                        <div class="pt" >
                            <div class="ptImg" >
                                <p>{{item.classname}}</p>
                                <img   :src="`http://www.bodenstil.com/${item.picurl}`" alt="">
                            </div>
                        </div>
                    </div>
                </swiper-slide>
            </swiper>
            <div class="btn prev ">
                <i class="el-icon-arrow-left"></i>
            </div>
            <div class="btn next ">
                <i class="el-icon-arrow-right"></i>
            </div>
            <div class="swiper-pagination" slot="pagination"></div>
        </div>
    </div>
</template>

<script>
    import  {getHomeInfo} from "../util/lang";
    import aBtn from './btn'
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "mpro",
        data(){
          return{
              aStyle:'',
              swiperOption:{
                  notNextTick: true,
                  slidesPerView:1,//一行显示3个
                  speed:1000,
                  init:true,
                  loop:true,
                  centeredSlides : true,
                  spaceBetween :60,
                  setWrapperSize :true,
                  autoplay: false,
                  effect : 'fade',
                  fadeEffect: {
                      crossFade: true,
                  },
                  pagination: {
                      el: '.allImgs .swiper-pagination',
                      type: 'fraction'
                  },
                  navigation: {
                      prevEl: '.allImgs .btn.prev',
                      nextEl: '.allImgs .btn.next',
                  }
              }
          }
        },
        props:['products'],
        components:{
            swiper, swiperSlide,aBtn
        },
        methods:{
            gotoInfo(id){
                const  link=`./pro.html?id=${id}`
                window.open(link,'_self')
            },
            move(e){
                // let offsetX=e.offsetX
                // let offsetY=e.offsetY
                // let walk = 2
                // let  xWalk = (offsetX / 100) * (walk * 20) - (walk * 8)
                // let  yWalk = (offsetY / 150) * (walk * 10) - (walk * 5);
                // this.aStyle={transform:`translate(${xWalk}px, ${yWalk}px) scale(1.02)`}
            },
            goBack(){
                // this.aStyle={transform:'translate(0px, 0px) scale(1)'}
            },
        }
    }
</script>

<style lang="scss" scoped>
    .mpro {
        width: 100%;
        position: relative;
        .bgImg {
            width: 100%;
            img {
                width: 100%;
                display: block;
                object-fit: cover;
            }
        }
        .allImgs {
            width: 80%;
            left: 10%;
            top: 40px;
            position: absolute;
            .swiper {
                width: 100%;
                .item {
                    cursor: pointer;
                    width: 100%;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .left {
                        width: 40%;
                        cursor: pointer;
                        position: relative;
                        padding: 40px 40px;
                        transform: translateX(-1000px);
                        transition: all 2s;
                        opacity: 0;
                        &::before {
                            width: 88%;
                            height: 91%;
                            background: rgba(235, 233, 230, 0.6);
                            content: "";
                            display: inline-block;
                            position: absolute;
                            left: 3%;
                            top: 2.5%;
                            z-index: -1;
                        }
                        &::after {
                            width: 90%;
                            height: 92%;
                            background: rgba(235, 233, 230, 0.5);
                            content: "";
                            display: inline-block;
                            position: absolute;
                            left: -20px;
                            top: 0;
                            z-index: -2;
                        }
                        img {
                            width: 100%;
                            display: block;
                            object-fit: cover;
                            transition: all 2s;
                        }
                        &:hover {
                            img {
                                transform: scale(1.02);
                            }
                        }
                    }
                    .right {
                        width: 48%;
                        transform: translateX(1000px);
                        opacity: 0;
                        transition: all 2s;
                        transition-delay: 500ms;
                        padding: 0 4%;
                        .title {
                            margin-top: 30px;
                            p:nth-child(1) {
                                font-size: 24px;
                                font-family: "DINNeuzeitGroteskStd-Light";
                                text-transform: uppercase;
                            }
                            p:nth-child(2) {
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                font-family: "it";
                                font-weight: lighter;
                                font-size: 14px;
                                margin: 15px auto;
                                &::before {
                                    width: 30px;
                                    height: 1px;
                                    background: rgba(187, 187, 187, 1);
                                    content: "";
                                    display: inline-block;
                                    margin-right: 10px;
                                }
                            }
                        }
                        .nr {
                            color: #4b4b4b;
                            font-size: 14px;
                            font-family: "it";
                            margin: 60px 0;
                            line-height: 30px;
                        }
                        .pt {
                            width: 100%;
                            .ptImg{
                                /*width:50%;*/
                                margin-left: 40%;
                                transition: all 600ms;
                                display: flex;
                                flex-direction: row;
                                align-items: center;
                                justify-content: flex-end;
                                position: relative;
                                overflow: hidden;
                                /*<!--&::before{-->*/
                                /*<!--    position: absolute;-->*/
                                /*<!--    top: 0;-->*/
                                /*<!--    left: 0;-->*/
                                /*<!--    width: 100%;-->*/
                                /*<!--    height: 100%;-->*/
                                /*<!--    background: rgba(0,0,0,.2);-->*/
                                /*<!--    content: '';-->*/
                                /*<!--    -webkit-transition: -webkit-transform .6s;-->*/
                                /*<!--    transition: transform .6s;-->*/
                                /*<!--    -webkit-transform: scale3d(1.9,1.4,1) rotate3d(0,0,1,45deg) translate3d(0,-100%,0);-->*/
                                /*<!--    transform: scale3d(1.9,1.4,1) rotate3d(0,0,1,45deg) translate3d(0,-100%,0);-->*/
                                /*<!--    pointer-events: none;-->*/
                                /*<!--}-->*/
                                p {
                                    color: #4f4f4b;
                                    font-size: 20px;
                                    font-family: "itbook";
                                    text-transform: uppercase;
                                    transition: all 600ms;
                                    z-index: 10;
                                }
                                img {
                                    transition: all 600ms;
                                    z-index: 1;
                                }
                                &:hover {
                                    /*&::before{*/
                                    /*    transform: scale3d(1.9,1.4,1) rotate3d(0,0,1,45deg) translate3d(0,100%,0);*/
                                    /*}*/
                                    transform: translate(80px,-50px) scale3d(1.1,1.1,1.1);
                                    p {
                                        transform: translateX(100px);
                                    }
                                    img {
                                        transform: scale(1.04);
                                    }
                                }
                            }
                        }
                    }
                }
                .swiper-slide-active {
                    .left {
                        transform: translateX(0);
                        opacity: 1;
                    }
                    .right {
                        transform: translateX(0);
                        opacity: 1;
                    }
                }
            }
            .prev {
                position: absolute;
                left: 46%;
                bottom: 5%;
                color: rgba(79, 79, 75, 0.4);
                cursor: pointer;
                transition: all 1s;
                z-index: 1000;
                text-align: center;
                i {
                    font-size: 20px;
                }
            }
            .next {
                position: absolute;
                left: 53%;
                bottom: 5%;
                color: rgba(79, 79, 75, 0.4);
                cursor: pointer;
                transition: all 1s;
                z-index: 1000;
                text-align: center;
                i {
                    font-size: 20px;
                }
            }
            .btn:hover {
                color: #f7c66b;
            }
            .btn:focus {
                outline: none;
            }
        }
    }
    @media screen and (max-width: 1440px) {
        .mpro{
           .allImgs{
               .swiper{
                   .item{
                       .left{
                           &::before{
                               height: 71%;
                           }
                           &::after{
                               height: 75%;
                           }
                       }
                   }
               }
           }
        }
    }
    @media screen and (max-width: 1300px) {
        .mpro {
            width: 90%;
            left: 5%;
            .bgImg{
                display: none;
            }
            .allImgs {
                position: relative;
                width: 100%;
                left: 0;
                top: 0;
                margin-top: 20px;
                .swiper {
                    .item {
                        display: block;
                        .left {
                            width: 100%;
                            padding: 0;
                            img {
                            }
                        }
                        .right {
                            width: 100%;
                            padding: 0;
                            .nr{
                                margin: 20px 0;
                            }
                        }
                    }
                }
                .prev,.next{
                    bottom: 0;
                }
                .prev{
                    left: 35%;
                }
                .next{
                    left: unset;
                    right: 35%;
                }
            }
        }
    }
</style>

<style scoped>
    .allImgs .swiper-pagination{
        right:40%;
        bottom:5%;
        position: absolute;
    }
    .allImgs .swiper-pagination >>> span{
        color:#61605A;
        font-family: "it";
    }
</style>
